module.exports = "./img/7e1fddf33d01c1a4caf35dc16bb53486.jpg";